import { Col } from "react-bootstrap";

import DateTimePicker from "./DateTimePicker";

const TableCalendarFilter = ({
  start,
  setStart = () => {},
  end,
  setEnd = () => {},
}) => {
  return (
    <>
      <Col sm="6" md="4" lg="3" xxl="2" className="mt-3">
        <label className="form-label" htmlFor="type">
          از تاریخ
        </label>
        <DateTimePicker
          placeholder="از تاریخ را وارد نمایید"
          initValue={start}
          onChange={setStart}
          withTime
          showTimeInput
        />
      </Col>

      <Col sm="6" md="4" lg="3" xxl="2" className="mt-3">
        <label className="form-label" htmlFor="type">
          تا تاریخ
        </label>
        <DateTimePicker
          placeholder="تا تاریخ را وارد نمایید"
          initValue={end}
          onChange={setEnd}
          withTime
          showTimeInput
        />
      </Col>
    </>
  );
};

export default TableCalendarFilter;
